/* cadou — Spezifikations-Sektion.
   Scroll-Fortschritt schaltet den aktiven Feature-Punkt und blendet
   das zugehörige Panel-Bild ein. Welches Bild zu welchem Punkt gehört,
   steht in data-for-feature am Bild — nicht in seiner Position, denn
   nicht jeder Block muss ein Bild haben. */
(() => {
  const REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const instances = new Map();

  function init(root) {
    // Idempotent: shopify:section:load feuert im Theme-Editor auch beim
    // ersten Rendern, zusaetzlich zu boot(). Ohne diesen Guard liefen zwei
    // ScrollTrigger auf derselben Section, und der erste Teardown ginge
    // beim zweiten instances.set() verloren.
    if (instances.has(root)) destroy(root);

    const zone = root.querySelector('[data-spez-zone]');
    const features = [...root.querySelectorAll('[data-feature]')];
    const imgs = [...root.querySelectorAll('[data-spez-image]')];
    if (!zone || !features.length) return;

    // Nicht jeder Feature-Block muss ein Bild haben. Gesucht ist das
    // letzte Bild, dessen Block-Index nicht hinter dem aktiven Feature
    // liegt — ein Bild bleibt also stehen, bis ein spaeterer Block ein
    // neues mitbringt. Ueber die Position im Panel zu zaehlen waere
    // falsch, sobald ein Block ohne Bild dazwischen liegt.
    function bildSetzen(i) {
      if (!imgs.length) return;
      let im = 0;
      for (let n = 0; n < imgs.length; n++) {
        if (Number(imgs[n].dataset.forFeature) <= i) im = n;
      }
      imgs.forEach((el, n) => el.classList.toggle('is-active', n === im));
    }

    if (REDUCED || !window.ScrollTrigger) {
      /* Ohne Scroll-Steuerung stehen alle Punkte gleichzeitig da. Das
         Panel braucht trotzdem ausdruecklich ein aktives Bild: die Bilder
         starten auf opacity:0 und sind unter 900px zusaetzlich auf
         display:none gesetzt. Fehlte is-active, bliebe das Panel leer —
         nicht nur bei prefers-reduced-motion, sondern bei jedem, dessen
         ScrollTrigger nicht geladen hat. */
      features.forEach(f => f.classList.add('is-active'));
      bildSetzen(0);
      return;
    }

    let active = -1;
    function setActive(i) {
      if (i === active) return;
      active = i;
      features.forEach((f, n) => f.classList.toggle('is-active', n === i));
      bildSetzen(i);
    }
    setActive(0);

    const trigger = ScrollTrigger.create({
      trigger: zone,
      start: 'top top',
      end: 'bottom bottom',
      scrub: 0.3,
      onUpdate: self => {
        const i = Math.min(features.length - 1, Math.floor(self.progress * features.length));
        setActive(i);
      }
    });

    instances.set(root, () => trigger.kill());
  }

  function destroy(root) {
    const teardown = instances.get(root);
    if (teardown) { teardown(); instances.delete(root); }
  }

  const boot = () => document.querySelectorAll('.spec-split').forEach(init);
  if (document.readyState === 'loading') addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', e => {
    e.target.querySelectorAll('.spec-split').forEach(init);
  });
  document.addEventListener('shopify:section:unload', e => {
    e.target.querySelectorAll('.spec-split').forEach(destroy);
  });
})();
